import {
  InternetExplorerNavigator,
  TrackingOptions,
  TrackingOptionsInferred,
} from "./shared.modules";
import { getCookie } from "./utils/cookies";
import { isClientSessionStart } from "./utils/client_session";
import pkg from "../package.json";
import { getTrackingLandingParameters } from "./utils/track_landing_params";
import { clearSessions, sessionIdentifiers } from "./utils/client_identifier";
import { getMusementId } from "./getMusementId";
import getParentWindowUrl from "./utils/parentWIndowUrl";

const logConsole = localStorage.getItem("trackingJSclient_enableLog");

export default function musementTracking(options: TrackingOptions) {
  "use strict";

  const landingParameters = getTrackingLandingParameters(
    window.location.search
  );

  // Default settings
  const defaultData: Partial<TrackingOptions> & TrackingOptionsInferred = {
    useragent: navigator.userAgent.substring(0, 300),
    acceptlanguage:
      (window.navigator as InternetExplorerNavigator).userLanguage ||
      window.navigator.language,
    env: null,
    url: document.URL.substring(0, 300),
    referrer: document.referrer.substring(0, 300),
    parentWindowUrl: getParentWindowUrl(),
    locale: null,
    deviceType: null,
    web_id: getMusementId(),
    landingParams: landingParameters,
    ...sessionIdentifiers(),
    maid: getCookie("_mafuid"),
    countryId: null,
    countryName: null,
    regionName: null,
    cityId: null,
    cityName: null,
    venueId: null,
    eventsId: null,
    transactionId: null,
    currency: null,
    page_type: null,
    eventName: null,
    eventValue: null,
    eventAttribute: null,
    deeplink: null,
    deeplink_error: null,
    experiment_id: null,
    cartId: null,
    widgetId: null,
    partnerUrl: null,
    appinstalltoken: null,
    customerId: null,
    categoryId: null,
    editorialcategoryId: null,
    listId: null,
    latitudeIP: null,
    longitudeIP: null,
    source: null,
    ab_test_config: null,
    is_session_start: isClientSessionStart(),
    cookiesAcceptance: null,
    custom1: null,
    custom2: null,
    custom3: null,
    cachebuster: Date.now(),
    devConsole: false,
    ver: pkg.version,
    testMode: false,
    reps_country: null,
    reps_city: null,
    reps_hotel: null,
    b2cTrkVersion: null,
  };

  // Merge user options into defaults
  const data = {
    ...defaultData,
    ...options,
  };

  const sanitizedData = Object.keys(data).reduce((result, key) => {
    const value = data[key];
    if (key === "url" || key === "referrer") {
      result[key] = urlSanitize(value);
    } else if (value !== null) {
      result[key] = value;
    }
    return result;
  }, {});

  const url =
    process.env.URL_ENDPOINT +
    window.btoa(encodeURIComponent(JSON.stringify(sanitizedData)));

  const image = new Image(1, 1);
  image.src = url;

  if (url.length > 10254) {
    console.error("Crumbs: The url seems to be too long for a image: " + url);
  }

  if (data.devConsole || logConsole) {
    console.log("Crumbs: ", sanitizedData);
  }

  if (data.testMode) {
    return url;
  }

  /**
   * Cleans the msmCrypt query parameter from a url
   * @param originalUrl url as string to sanitize
   * @returns safe url to send throw internet
   */
  function urlSanitize(originalUrl) {
    if (!originalUrl || typeof originalUrl !== "string") {
      return originalUrl;
    }
    return originalUrl.replace(
      /^((?:https?):\/\/[^\s$.?#].[^\s]*[\?&]msmCrypt=)(?:[^&]+)(&.*)?$/,
      "$1track_replaced$2"
    );
  }
}

musementTracking.clearSessions = clearSessions;
musementTracking.getMusementId = getMusementId;

(window as any).musementTracking = musementTracking;
